import { Grid, Paper, Box, Typography, Button, Link } from '@mui/material';
import cbpLogoImg from '../../assets/images/CBP-Logo.png';
import boxIconImg from '../../assets/images/BoxIcon.png';

import './Visualizer.styles.css';

const Visualizer = () => {
  return (
    <Grid container direction="row">
      <Grid size={{ xs: 12 }}>
        <Grid container direction="row">
          <Grid size={{ xs: 12 }}>
            <Paper className="BannerBox">
              <Box className="BannerOverlay">
                <Box className="BannerContainer">
                  <Box className="BannerLogo">
                    <img src={cbpLogoImg} alt="Box Icon" />
                  </Box>
                  <Box className="BannerContent">
                    <Box className="BannerTitle">
                      <img src={boxIconImg} alt="Box Icon" />
                      <Typography variant="h1" className="MainHeading">
                        Tile & Grout Visualizer
                      </Typography>
                    </Box>
                    <Box className="BannerSubTitle">
                      <Typography variant="body1" className="BannerText">
                        Whether you have a tile picked out or you are still looking for inspiration,
                        use our vizualizer to find a grout that works for you.
                      </Typography>
                    </Box>
                    <Box className="BannerButton">
                      <Link href="#/visualizer/select-tile" className="NoUnderline GetStartedLink">
                        {' '}
                        <Button className="" color="primary" variant="outlined">
                          Get Started
                        </Button>
                      </Link>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Visualizer;
